module.exports = __webpack_public_path__ + "img/loader.4dabbe74.svg";